import _ from 'underscore';

import { ApiCall } from './api-call';

/*
  api.js is heavily inspired by axios-actions (nearly a fork).
*/

/**
 * Api is a base class containing an axios instance which can be extended in
 * order to group related API calls.
 */
export class Api {
  axios = null;

  constructor(axios, endpoints) {
    this.axios = axios;
    if (endpoints) {
      this.createEndpoints(endpoints);
    }
  }

  /**
   * Create endpoints on this API instance
   *
   * `endpoints` is an object of one of two forms:

    Simple method names to URLs:

    {
      method_name: "url",
      read: "/some/url/path",
      write: "/some/other/path"
    }

    Or URLs plus extra ApiCall options:

    {
      method_name: [ url, opts ],
      read: [ "/some/url/path", { model: Foo, plugins: [Baz, Bar] }]
    }
   *
   *
   * @param {Object} endpoints to add to this API
   */
  createEndpoints(endpoints) {
    Object.keys(endpoints).forEach((key) => {
      const v = endpoints[key];
      let url;
      let opts = null;
      if (_.isString(v)) {
        url = v;
      } else {
        // assume array of url + opts
        [url, opts] = v;
      }
      if (!opts) {
        opts = {};
      }
      // set default axios instance, if needed
      if (!opts.axios) {
        opts.axios = this.axios;
      }
      this[key] = new ApiCall(url, opts).create();
    });
  }
}
